import List from '@utils/list'
import { $t } from '@plugin/i18n'
// import getData from './config/getData'
import Select from '@utils/common/select'
// console.log(getData)
// import { Select } from '@utils/index'
const { Detail, Search, Table } = List

// const n = (i: any) => `<span style="color: red;">${i || '&nbsp'}</span>`
const n = (a: any, b: any) => `<span${a === b ? '' : ' style="color: red;"'}>${a || '&nbsp'}<br>${b || '&nbsp'}</span>`

// const jurisdiction = new Jurisdiction()
//   .lib('manual').access('/sysQuartzJob/runPurchaseChangeJob', process.env.VUE_APP_SCHEDULE_API)

// const select = Select.copy('/purchaseUnit/getPurchaseUnitPage').params({ usingFlag: '1' })

const search = new Search('orderpurchase.orderchange')
  .placeholder('searchPlaceholder')
  // .add('purchaseUnitNo').select(select)
  .lib('dateRange')
  .prop(['purchaseChgDateStart', 'purchaseChgDateEnd'])
  .mapKey('dateRange1')
  .label('purchaseDate')
  .add('purchaseUnitNo')
  .label('purchaseUnitNo')
  .select(
    Select.use('/purchaseUnit/getPurchaseUnitPage').params({ usingFlag: '1' })
  )
// .lib('dateRange').prop(['deliveryDateStart', 'deliveryDateEnd']).label('deliveryDate').br()
// .add('outPurchaseNo')

const table = new Table('orderpurchase.orderchange')
  .sortable(false)
  .type('index')
  .add('purchaseChgNo')
  .width(135)
  .sort(true)
  .link()
  .add('purchaseChgDate')
  .width(140)
  .sort(true)
  .add('purchaseNo')
  .width(135)
  .label('orderpurchase.labelprinting.purchaseNo')
  .sort(true)
  .add('purchaseChgVersion')
  .label('orderpurchase.orderchange.purchaseChgbanbeng')
  .add('supplierName')
  .add('employeeName')
  .add('purchaseUnitName')
  .label('purchaseUnitNo')
  .add('period')
  .label('')
  .html(
    () =>
      `${$t('orderpurchase.orderchange.period1')}<br>${$t(
        'orderpurchase.orderchange.period2'
      )}`
  )
  .add('taxRateMark')
  .html(({ row }) => `${n(row.taxRateBefore, row.taxRateAfter)}`)
  .add('taxTypeNameMark')
  .html(
    ({ row }) => `${n(row.taxTypeNameBefore, row.taxTypeNameAfter)}`
  )
  .add('currencyNameMark')
  .html(
    ({ row }) => `${n(row.currencyNameBefore, row.currencyNameAfter)}`
  )
  .add('txTermsNameMark')
  .html(
    ({ row }) =>
      `${n(row.tranConditonNameBefore, row.tranConditonNameAfter)}`
  )
  // .add('dataSourceMark').html(({ row }) => `${n(row.dataSourceName, row.dataSourceAfterName)}`)
  // .add('outPurchaseNoMark').html(({ row }) => `${n(row.outPurchaseNoChg, row.outPurchaseNoAfter)}`).width(150)
  .add('remarks')
  .html(({ row }) => `${row.remarks || ''}`)

const detailTable = new Table('orderpurchase.orderchange')
  .sortable(false)
  .type('index')
  .add('purchaseNoX')
  .html(
    ({ row }) =>
      `${row.purchaseSeq}-${row.purchasePhaseSeq}-${row.purchaseBatchSeq}`
  )
  // .add('goodsInfo').html(({ row }) => `${$t('orderpurchase.orderchange.goodsNo')}: ${row.goodsNo}<br>${$t('orderpurchase.orderchange.goodsName')}: ${row.goodsName}<br>${$t('orderpurchase.orderchange.spec')}: ${row.spec}`)
  .add('period')
  .label('')
  .html(
    () =>
      `${$t('orderpurchase.orderchange.period1')}<br>${$t(
        'orderpurchase.orderchange.period2'
      )}`
  )
  .add('batchPurMark')
  .html(({ row }) => `${n(row.purQtyBefore, row.purQtyAfter)}`)
  .add('liaohao')
  .html(({ row }) => `${n(row.goodsNoBefore, row.goodsNoAfter)}`)
  .add('goodsName')
  .html(({ row }) => `${n(row.goodsNameBefore, row.goodsNameAfter)}`)
  .add('spec')
  .html(({ row }) => `${n(row.specBefore, row.specBefore)}`)
  .add('unitNo')
  .html(({ row }) => `${n(`${row.unitNoBefore}-${row.unitNameBefore}`, `${row.unitNoAfter}-${row.unitNameAfter}`)}`)
  .add('valuationUnitNo')
  .html(({ row }) => `${n(`${row.valuationUnitNoBefore}-${row.valuationUnitNameBefore}`, `${row.valuationUnitNoAfter}-${row.valuationUnitNameAfter}`)}`)
  .add('batchValuationMark')
  .html(({ row }) => `${n(row.valuationQtyBefore, row.valuationQtyAfter)}`)
  .add('priceMark')
  .html(({ row }) => `${n(row.unitPirceBefore, row.unitPriceAfter)}`)
  .add('taxTypeNameMark')
  .html(({ row }) => `${n(row.taxTypeNameBefore, row.taxTypeNameAfter)}`)
  .add('taxRateMark')
  .html(({ row }) => `${n(row.taxRateBefore, row.taxRateAfter)}`)
  .add('batchTaxIncludedAmountMark')
  .html(({ row }) => `${n(row.taxAmountBefore, row.taxAmountAfter)}`)
  .add('batchPreTaxAmountMark')
  .html(({ row }) => `${n(row.noTaxAmountBefore, row.noTaxAmountAfter)}`)
  .add('batchTaxAmountMark')
  .html(({ row }) => `${n(row.diffAmountBefore, row.diffAmountAfter)}`)
  .add('arrivalDateMark')
  .width(170)
  .html(
    ({ row }) =>
      `${n(row.expectArrivalDateBefore, row.expectArrivalDateAfter)}`
  )
  .add('remarksMark')
  .html(({ row }) => `${n(row.remarksBefore, row.remarksAfter)}`)
  // .add('unreceivedAmount').width(200).html(({ row }) => `${row.outPurchaseSeqChg}-${row.outPurchasePhaseSeqChg}-${row.outPurchaseBatchSeqChg}<br>${row.outPurchaseSeq}-${row.outPurchasePhaseSeq}-${row.outpurchaseBatchSeq}`)
  .add('chgReason')
  .html(
    ({ row }) =>
      `${n(row.purchaseChgReasonBefore, row.purchaseChgReasonAfter)}`
  )

const detail = new Detail('orderpurchase.orderchange')
  .url('/srmPurChg/getPurChgBody', process.env.VUE_APP_PURCHASE_API)
  .params((row) => {
    return {
      purchaseChgNo: row.purchaseNo,
      site: row.site,
      plant: row.plantNo,
      ent: row.ent,
      purchaseChgVersion: row.purchaseChgVersion
    }
  }) // 待定
  // .getData(getData)
  // ({ purchaseNoChg: row.purchaseNoChg, chgRevesion: row.chgRevesion })
  .table('list', detailTable)

export default new List()
  .url('/srmPurChg/getPurChgHead', process.env.VUE_APP_PURCHASE_API)
  .sort({ field: 'purchaseChgDate', order: 'desc' })
  .search(search)
  .table(table)
  .detail(detail)
  .end()
